import { StoreAction, XmAction } from 'store/actions';
import { NowMobileLandingCollection } from './models/mobile-landing';
import { NowDataUsageCollection } from './models/data-usage';
import { NowXMUpgrade } from './models/upgrade';

export function nowMobileLandingReducer(state: NowMobileLandingCollection, action: XmAction<NowMobileLandingCollection>): NowMobileLandingCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_MOBILE_LANDING:
            return action.payload;
        case StoreAction.CLEAR_NOW_MOBILE_LANDING:
            return undefined;
        default:
            return state;
    }
}

export function nowDataUsageReducer(state: NowDataUsageCollection, action: XmAction<NowDataUsageCollection>): NowDataUsageCollection {
    switch (action.type) {
        case StoreAction.GET_NOW_DATA_USAGE:
            return action.payload;
        default:
            return state;
    }
}

export function nowXMUpgradeReducer(state: NowXMUpgrade, action: XmAction<NowXMUpgrade>): NowXMUpgrade {
    switch (action.type) {
        case StoreAction.GET_NOW_XM_UPGRADE_DATA:
            return action.payload;
        default:
            return state;
    }
}
